// extracted by mini-css-extract-plugin
export var colorSquare = "_nh-0";
export var container = "_nh-h";
export var danger = "_nh-5";
export var lightPink = "_nh-8";
export var neutralBlue = "_nh-7";
export var neutralYellow = "_nh-6";
export var normal = "_nh-1";
export var primary = "_nh-2";
export var primaryLight = "_nh-3";
export var selected = "_nh-i";
export var solidBlack = "_nh-g";
export var solidGreen = "_nh-b";
export var solidLightBlue = "_nh-d";
export var solidNavy = "_nh-c";
export var solidOrange = "_nh-f";
export var solidPink = "_nh-e";
export var solidRed = "_nh-9";
export var solidYellow = "_nh-a";
export var success = "_nh-4";